// extracted by mini-css-extract-plugin
export default {"SignUpForm":"SignUpForm_SignUpForm__OHA-Y","Alert":"SignUpForm_Alert__uyPiE","SignUpButton":"SignUpForm_SignUpButton__BPMXm"};